exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".trustpilot-widget iframe[data-v-d3ae642a]{align-self:center;display:flex}", ""]);

